/* eslint-disable import/no-unresolved */
/* eslint-disable prettier/prettier */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import axios from 'axios';
import environment from '../../configs/environment.configs';

// configs

/* -------------------------------------------------------------------------- */
/*                                  Services                                  */
/* -------------------------------------------------------------------------- */


const getIPv4Address = async (fallbackIp) => {
  try {
    const { ip } = await (await fetch("https://api4.ipify.org?format=json")).json();
    return ip;
  } catch {
    return fallbackIp;
  }
};

class IpServices {
  static get = async () => {
    let { data } = await axios.get(
      `${environment.ipApi.baseUrl}/check?access_key=${environment.ipApi.accessKey}&fields=country_code,ip`
    );

    if (data.ip.includes(':')) {
      data.ip = await getIPv4Address(data.ip);
      data = (await axios.get(
        `${environment.ipApi.baseUrl}/${data.ip}?access_key=${environment.ipApi.accessKey}&fields=country_code,ip`
      )).data;
    }

    return { ip: data.ip, countryCode: data.country_code };
  };
}

export default IpServices;
